import gql from 'graphql-tag';

export const CreateDispatchIssueCausedBy = gql`
  mutation CreateDispatchIssueCausedByBulk($input: CreateDispatchIssueCausedByBulkInput!) {
    createDispatchIssueCausedByBulk(input: $input) {
      output {
        error
        node {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          causedById
          dispatchIssueId
        }
      }
    }
  }
`;
